module.exports = __webpack_public_path__ + "static/media/size3.0bee1910.svg";